import request from '@/utils/request'
const baseUrl = '/personal'

const publishPost = data =>
  request({
    url: `${baseUrl}/communitypost/add`,
    method: 'POST',
    data
  })

const communityList = data =>
  request({
    url: `${baseUrl}/communitypost/page`,
    method: 'POST',
    data
  })

const getScore = data =>
  request({
    url: `${baseUrl}/communityuserintegral/selectUserId`,
    method: 'POST',
    data
  })

const getPostDetail = data =>
  request({
    url: `${baseUrl}/communitypost/detail`,
    method: 'POST',
    data
  })

const editPostDetail = data =>
  request({
    url: `${baseUrl}/communitypost/update`,
    method: 'POST',
    data
  })

const deletePost = data =>
  request({
    url: `${baseUrl}/communitypost/del`,
    method: 'POST',
    data
  })

const scceptAnswer = data =>
  request({
    url: `${baseUrl}/communitypost/adopt`,
    method: 'POST',
    data
  })

const commentList = data =>
  request({
    url: `${baseUrl}/communitycomment/detail`,
    method: 'POST',
    data
  })

const addComment = data =>
  request({
    url: `${baseUrl}/communitycomment/add`,
    method: 'POST',
    data
  })

const editComment = data =>
  request({
    url: `${baseUrl}/communitycomment/update`,
    method: 'POST',
    data
  })

const deleteComment = data =>
  request({
    url: `${baseUrl}/communitycomment/del`,
    method: 'POST',
    data
  })

const likeComment = data =>
  request({
    url: `${baseUrl}/communitypraise/add`,
    method: 'POST',
    data
  })

const cancelLikeComment = data =>
  request({
    url: `${baseUrl}/communitypraise/del`,
    method: 'POST',
    data
  })

const store = data =>
  request({
    url: `${baseUrl}/communitycollection/add`,
    method: 'POST',
    data
  })

const cancelStore = data =>
  request({
    url: `${baseUrl}/communitycollection/del`,
    method: 'POST',
    data
  })

const storeList = data =>
  request({
    url: `${baseUrl}/communitycollection/getMyCollection`,
    method: 'POST',
    data
  })

const weeklyCharts = () =>
  request({
    url: `${baseUrl}/communitypost/replyWeeks`,
    method: 'POST'
  })

const uploadFiles = (data) =>
  request({
    url: `${baseUrl}/tools/uploadingImagesUE`,
    method: 'POST',
    data
  })

export {
  publishPost,
  communityList,
  getScore,
  getPostDetail,
  commentList,
  editPostDetail,
  deletePost,
  scceptAnswer,
  addComment,
  editComment,
  deleteComment,
  likeComment,
  cancelLikeComment,
  store,
  cancelStore,
  storeList,
  weeklyCharts,
  uploadFiles
}



// WEBPACK FOOTER //
// ./src/api/community.js